<template>
  <div class="pricerowCondition" style="border-bottom: 1px #dddddd solid; margin-bottom: 10px; padding-bottom: 10px;">
    <div class="conditionRow conditionSelectorRow">
      <label class="conditionLabel ifLabel">{{ _('if') }}</label>
      <div class="conditionContent">
        <div class="form-inline conditionSelectorContainer">
          <div class="form-group">
            <select class="form-control conditionSelector" v-model="selectedCondition" v-on:input="conditionAdded($event.target.value)" :disabled="!!condition">
              <option value="">{{ _('-- select a condition --') }}</option>
              <option value="daterange" v-if="show('daterange')">{{ _('date range') }}</option>
              <option value="timerange" v-if="show('timerange')">{{ _('time range') }}</option>
              <option value="min" v-if="show('min')">{{ _('minimum duration') }}</option>
              <option value="max" v-if="show('max')">{{ _('maximum duration') }}</option>
              <option value="weekday" v-if="show('weekday')">{{ _('weekday') }}</option>
              <option value="startweekday" v-if="show('startweekday')">{{ _('start weekday') }}</option>
              <option value="endweekday" v-if="show('endweekday')">{{ _('end weekday') }}</option>
              <option value="minparticipants" v-if="show('minparticipants')">{{ _('minimum participants') }}</option>
              <option value="maxparticipants" v-if="show('maxparticipants')">{{ _('maximum participants') }}</option>
              <option value="minresources" v-if="show('minresources')">{{ _('minimum resources') }}</option>
              <option value="maxresources" v-if="show('maxresources')">{{ _('maximum resources') }}</option>
              <option value="route" v-if="show('route')">{{ _('route') }}</option>
              <option value="origin" v-if="show('origin')">{{ _('origin zone') }}</option>
              <option value="destination" v-if="show('destination')">{{ _('destination zone') }}</option>
            </select>
          </div>
        </div>
      </div>
      <button class="btn btn-danger" v-on:click="conditionRemoved(condition)" type="button"><i class="fa fa-fw fa-trash"></i></button>
    </div>
    <div class="conditionRow conditionValueRow" v-if="condition">
      <label class="conditionLabel">{{ _('is') }}</label>
      <div class="conditionContent">
        <div class="form-inline conditionValueContainer">
          <component v-if="condition" :is="componentType" :pricerow="pricerow" :routes="routes" :zones="zones" v-on:data="conditionChanged" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['pricerow', 'condition', 'conditions', 'routes', 'zones'],
  computed: {
    selectedCondition: {
      get () {
        return this.condition
      },
      set (newValue) {}
    },
    componentType () {
      return 'Pricerow' + this.condition.charAt(0).toUpperCase() + this.condition.slice(1)
    }
  },
  components: {
    PricerowDaterange: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowDaterange')),
    PricerowDestination: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowDestination')),
    PricerowEndweekday: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowEndweekday')),
    PricerowMax: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowMax')),
    PricerowMaxparticipants: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowMaxparticipants')),
    PricerowMaxresources: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowMaxresources')),
    PricerowMin: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowMin')),
    PricerowMinparticipants: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowMinparticipants')),
    PricerowMinresources: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowMinresources')),
    PricerowOrigin: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowOrigin')),
    PricerowRoute: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowRoute')),
    PricerowStartweekday: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowStartweekday')),
    PricerowTimerange: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowTimerange')),
    PricerowWeekday: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowWeekday')),
  },
  methods: {
    show (condition) {
      if (!this.conditions || this.condition === condition) {
        return true
      }
      return !this.conditions.includes(condition)
    },
    conditionAdded (data) {
      this.$emit('add', data)
    },
    conditionRemoved (data) {
      this.$emit('remove', data)
    },
    conditionChanged (data) {
      this.$emit('data', data)
    }
  },
}
</script>
